import { Sender } from '@ant-design/x';
import styled from 'styled-components';

export const StyledSender = styled(Sender)`
  background: #EFEEF1;
  color: #0D0A0A;
  display: flex;
  border-radius: 1.5rem;
  max-width: calc(100vw - 7rem) !important;
  min-height: 3rem !important;
  margin-left: 0.2rem;
  border: none;

  .ant-sender-actions-list {
    position: absolute;
    top: 0.5rem;
    right: -2.75rem;

    .ant-sender-actions-btn {
      background: transparent !important;
      box-shadow: none;

      :hover {
        background: white !important;
      }

      svg {
        transform: scale(2.4);
        path {
          fill: #00E24B;
        }
      }
    }
  }

  .ant-sender-input {
    overflow-y: auto !important;

    &::-webkit-scrollbar {
      width: 0.25rem;
    }

    &::-webkit-scrollbar-track {
      background: #EFEEF1;
      border-radius: 0.25rem;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--main-color);
      border-radius: 0.25rem;
    }
  }

  @media screen and (min-width: 48em) {
    max-width: 34.5rem !important;
  }
`;
